module.exports = __webpack_public_path__ + "img/activity3.ca9e2f2d.png";